import {
  Login,
  LoginContent,
  LogoContainer,
  SignInButton,
  LoginButton,
  Powered,
  ButtonsContent,
  TogatherWebsite,
} from '../../index.styled';
import Logo from '../../../assets/images/ChurchLogo.svg';
import AppleIco from '../../../assets/images/appleIcon.svg';
import GoogleIco from '../../../assets/images/googleIcon.svg';
import Link from 'next/link';
import GoogleLogin from 'react-google-login';
import AppleLogin from 'react-apple-login';
import { alertType } from '../../../constans/alert';
import { pageType } from '../../../constans/signin';

const IndexLayout = ({
  googleSignIn,
  appleSignIn,
  handleErrorData,
  handlePage,
  handleChurchChange,
  churchInfo,
}) => {
  return (
    <>
      <Login>
        <LoginContent>
          <LogoContainer>
            <img src={churchInfo?.logo} />
          </LogoContainer>
          <ButtonsContent>
            <Link href="/signup">
              <LoginButton color="white">Sign up with Email</LoginButton>
            </Link>
            <AppleLogin
              clientId={process.env.NEXT_PUBLIC_APPLE_CLIENT_ID}
              redirectURI="https://api.gettogather.co/allauth/apple/login/callback/"
              usePopup={true}
              render={(renderProps) => (
                <LoginButton
                  disabled={renderProps.disabled}
                  onClick={renderProps.onClick}
                  color="black"
                >
                  <AppleIco /> &ensp; Sign up with Apple
                </LoginButton>
              )}
              callback={(data) => {
                data.error
                  ? handleErrorData(
                      alertType.WARNING,
                      data.error.error,
                    )
                  : appleSignIn(data);
              }}
            />
            <GoogleLogin
              clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}
              redirectUri="https://api.gettogather.co/allauth/google/login/callback/"
              buttonText="Log in with Google"
              render={(renderProps) => (
                <LoginButton
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                  color="blue"
                >
                  <GoogleIco /> &ensp; Sign up with Google
                </LoginButton>
              )}
              onSuccess={(data) => googleSignIn(data.accessToken)}
              onFailure={(data) => {
                if (data.error === 'idpiframe_initialization_failed') return;
                handleErrorData(
                  alertType.WARNING,
                  data.error.replace(/_/g, ' '),
                );
              }}
              cookiePolicy={'single_host_origin'}
            />
            <SignInButton onClick={() => handlePage(pageType.login)}>
              Already have an account?&ensp; <b>Sign In</b>
            </SignInButton>
            <SignInButton onClick={handleChurchChange}>
              Not your church?&ensp; <b>Go to Search</b>
            </SignInButton>
          </ButtonsContent>
          <Link href='/'>
            <TogatherWebsite>Go to Togather’s Site</TogatherWebsite>
          </Link>
          <Powered>v1.1.1 (260) | © 2022 Togather</Powered>
        </LoginContent>
      </Login>
    </>
  );
};
//Not your church? Go to Search
export default IndexLayout;
